import { render, staticRenderFns } from "./CardRecomendedSlider.vue?vue&type=template&id=37d23b39&"
import script from "./CardRecomendedSlider.vue?vue&type=script&lang=js&"
export * from "./CardRecomendedSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports